import SessionPage from './components/SessionPage';
import ViolationPage from './components/ViolationPage';

const routes = [
  {
    path: '/session',
    name: 'menu.session',
    className: 'menu-session',
    icon: 'session',
    customIcon: true,
    loginRequired: true,
    component: SessionPage,
    weight: 1,
    permission: ['session'],
    children: [],
  },
  {
    path: '/session/violation',
    name: 'menu.session.violation',
    className: 'menu-session',
    icon: 'session',
    customIcon: true,
    loginRequired: true,
    hideOnMenu: true,
    component: ViolationPage,
    weight: 1,
    permission: [],
    children: [],
  },
];

export default routes;
